<template>
  <div class="login" :style="style">
    <div class="content">
      <div class="login-header">
        <a href="index.html" class="logo">
          <img src="/static/img/logo_color.png">
        </a>
      </div>
      <div class="login-body">
        <form id="login" @submit.prevent="submitForm">
          <input type="hidden" value="1" name="enviar">
          <div class="form-group">
            <input
              v-model="email"
              type="email"
              id="inputEmail"
              class="form-control"
              placeholder="Email"
              required
              autofocus
            >
          </div>
          <div class="form-group" v-if="formLogin">
            <input
              v-model="password"
              type="password"
              id="inputPassword"
              class="form-control"
              placeholder="Password"
              required
            >
          </div>
          <div class="result"></div>
          <div class="actions">
            <button class="btn btn-success btn-sm" type="submit">{{ btn }}</button>
          </div>
        </form>
      </div>
      <div class="login-footer">
        <a
          v-if="!formLogin"
          href="#"
          @click="returnLogin"
          class="text text__primary text__semibold text__16 text-center p-4 d-block"
        >Volver</a>
        <a
          v-else
          href="#"
          @click="remenberPass"
          class="text text__primary text__semibold text__16 text-center p-4 d-block"
        >¿Has olvidado la contraseña?</a>
      </div>
    </div>
  </div>
</template>
<script>
import sha1 from "sha1";
import { mapGetters, mapState } from "vuex";
import { LOGIN, RECOVERY_PASS } from "@/store/actions.type";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      formLogin: true,
      btn: "Entrar",
      style: null
    };
  },
  created() {
    let images = [
      "/static/img/imgs_entrada/tirme_entrada1.jpg",
      "/static/img/imgs_entrada/tirme_entrada2.jpg",
      "/static/img/imgs_entrada/tirme_entrada3.jpg",
      "/static/img/imgs_entrada/tirme_entrada4.jpg",
      "/static/img/imgs_entrada/tirme_entrada5.jpg"
    ];

    this.style =
      " background-image: url(" + images[Math.floor(Math.random() * 5)] + ");";
    this.checkCurrentLogin();
  },
  updated() {
    this.checkCurrentLogin();
  },
  methods: {
    checkCurrentLogin() {
      if (this.currentUser) {
        this.$router.replace(this.$route.query.redirect || "/home");
      }
    },
    submitForm() {
      this.formLogin ? this.login() : this.recoveryPass();
    },
    recoveryPass() {
      this.$store
        .dispatch(RECOVERY_PASS, { user: this.email })
        .then(response => this.msg(response.data.response, "info"))
        .catch(error => this.msg(error));
    },
    login() {
      this.$store
        .dispatch(LOGIN, { user: this.email, pass: sha1(this.password) })
        .then(response => this.loginSuccessful(response))
        .catch(error => this.loginFailed(error));
    },
    loginSuccessful(response) {
      if (!response.token) {
        this.loginFailed(response);
        return;
      }
      this.error = false;
      localStorage.token = response.token;

      this.msg("Login correcto!", "success");
      this.$router.replace(
        this.$route.query.redirect || { name: "Pre-dashboard" }
      );
    },
    loginFailed(request) {
      this.msg(request, "error");
      this.$store.dispatch("logout");
      delete localStorage.token;
    },
    remenberPass() {
      this.btn = "Recuperar contraseña";
      this.formLogin = false;
    },
    returnLogin() {
      this.formLogin = !this.formLogin;
      this.btn = "Entrar";
    },
    msg(msg, type) {
      this.$notify({
        title: msg,
        position: "bottom-right",
        type: type,
        duration: 5000
      });
    }
  },
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
    ...mapState({ errors: state => state.auth.errors })
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro");

.login {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  position: absolute;
  height: 100vh;
  width: 100vw;
}

body {
  font-family: "Source Sans Pro", sans-serif;
  -webkit-font-smoothing: antialiased;
  background: #fff;
  font-size: 14px;
  line-height: 1.42857143;
  color: #333;

  background: #9795bb;
  background-image: -webkit-radial-gradient(
    circle farthest-side at right bottom,
    #9795bb,
    #59688d 80%,
    #426686
  );
  background-image: -moz-radial-gradient(
    circle farthest-side at right bottom,
    #9795bb,
    #59688d 80%,
    #426686
  );
  background-image: -o-radial-gradient(
    circle farthest-side at right bottom,
    #9795bb,
    #59688d 80%,
    #426686
  );
  background-image: -ms-radial-gradient(
    circle farthest-side at right bottom,
    #9795bb,
    #59688d 80%,
    #426686
  );
  background-image: radial-gradient(
    circle farthest-side at right bottom,
    #9795bb,
    #59688d 80%,
    #426686
  );

  .clear {
    background-image: none;
    background: #f2f5f8;
  }
  .clear .logo .brankic-pen {
    color: #8caac0;
  }
  .clear h3 {
    color: #323438;
  }
  .clear .content {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);
    border-radius: 4px;
  }
  .clear .bottom-wrapper .message {
    text-shadow: 1px 1px #fff;
    border: 1px solid #c7cfd3;
    color: #333;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.82),
      0 1px 0 rgba(255, 255, 255, 0.83);
  }
  .clear .bottom-wrapper .message a {
    color: #428bca;
  }
}
.logo {
  margin-top: 0px;
  text-align: center;
  display: block;
  text-decoration: none;
}
.logo .brankic-pen {
  color: #ffffd8;
  font-size: 40px;
}
@media (max-width: 767px) {
  .logo .brankic-pen {
    font-size: 34px;
  }
}
h3 {
  font-size: 26px;
  color: #fff;
  text-align: center;
  margin-top: 35px;
}
@media (max-width: 767px) {
  h3 {
    font-size: 20px;
    margin-top: 15px;
  }
}
.content {
  max-width: 620px;
  margin: 0 auto;
  margin-top: 40px;
  background: #fff;
  box-shadow: 0 1px 40px 0 rgba(0, 0, 0, 0.3);
  border-radius: 3px;
}

@media (max-width: 767px) {
  .content {
    max-width: 90%;
    padding: 35px;
  }
}
.content .fields {
  margin-bottom: 50px;
}

.content .fields strong {
  display: block;
  margin-bottom: 20px;
}

.content .fields input[type="text"],
.content .fields input[type="password"] {
  margin-bottom: 15px;
}

.content .info {
  margin-top: -10px;
}

.content .signup {
  margin-top: 40px;
  text-align: center;
  margin-bottom: 20px;
}

.bottom-wrapper {
  padding-bottom: 120px;
}

.bottom-wrapper .message {
  max-width: 360px;
  margin: 0 auto;
  margin-top: 60px;
  text-align: center;
  border-radius: 4px;
  padding: 18px;
  border: 1px solid #8b9bc4;
  color: #fff;
}

.bottom-wrapper .message a {
  margin-left: 6px;
  color: #fff;
}

.clear {
  background-image: none;
  background: #f2f5f8;
}

.image-bg {
  background-image: "";
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  height: 100vh;
}

.clear .logo .brankic-pen {
  color: #8caac0;
}

.clear h3 {
  color: #323438;
}

.clear .content {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}

.clear .bottom-wrapper .message {
  text-shadow: 1px 1px #fff;
  border: 1px solid #c7cfd3;
  color: #333;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.82),
    0 1px 0 rgba(255, 255, 255, 0.83);
}

.clear .bottom-wrapper .message a {
  color: #428bca;
}

.signup-switcher {
  position: absolute;
  top: 170px;
  right: 0;
}

.signup-switcher a {
  display: block;
  background: #fff;
  padding: 5px 20px;
  margin-bottom: 10px;
  border-radius: 3px 0 0 3px;
  color: #3a3a3a;
  border: 1px solid #c9dbf5;
  border-right: 0;
  text-decoration: none;
}

.signup-switcher a[data-class=""] {
  background: #5a7a9e;
  color: #fff;
  border-color: #8da5c4;
}

.signup-switcher a[data-class=""] .fa-check {
  color: #fff;
}

.signup-switcher a.active .fa-check {
  opacity: 1;
}

.signup-switcher a .fa-check {
  color: #83c490;
  font-size: 14px;
  position: relative;
  top: 1px;
  right: 6px;
  margin-right: 5px;
  opacity: 0;
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.logo {
  margin-top: 0px;
  margin-bottom: 0px;
  text-align: center;
  display: block;
  text-decoration: none;
}

.logo .brankic-pen {
  color: #ffffd8;
  font-size: 40px;
}

@media (max-width: 767px) {
  .logo .brankic-pen {
    font-size: 34px;
  }
}

h3 {
  font-size: 24px;
  color: #fff;
  text-align: center;
  margin-top: 35px;
}

@media (max-width: 767px) {
  h3 {
    font-size: 20px;
    margin-top: 15px;
  }
}

.login-header {
  border-bottom: 1px solid #ebebeb;
  padding: 35px 0 35px;
  background-color: #fbfbfb;
  text-align: center;
}

.login-body {
  padding: 40px 85px 9px;
}

.login-footer {
  border-top: 1px solid #ebebeb;
  padding: 25px 0;
  font-style: italic;
  background-color: #fbfbfb;
  text-align: center;
}

.content {
  max-width: 385px;
  margin: 0 auto;
  margin-top: 120px;
  /*padding: 42px 48px;*/
  background: #fff;
  box-shadow: 0 1px 40px 0 rgba(0, 0, 0, 0.3);
  border-radius: 3px;
}

@media (max-width: 767px) {
  .content {
    max-width: 80%;
  }
}

.content .fields {
  margin-bottom: 20px;
}

.content .fields strong {
  display: block;
  margin-bottom: 10px;
}

.content .fields input[type="text"],
.content .fields input[type="password"] {
  margin-bottom: 15px;
}

.content .info {
  margin-top: 40px;
}

.content .actions {
  margin-top: 30px;
  text-align: center;
  margin-bottom: 10px;
}

.bottom-wrapper {
  border-radius: 4px;
  padding: 18px;
  border: 1px solid #8b9bc4;
  color: #fff;
}

.bottom-wrapper .message a {
  margin-left: 6px;
  color: #fff;
}

.btn.btn-success {
  border: 1px solid #63a042;
  background-color: #76b852;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.14),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.btn.btn-default {
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0), inset 0 0px 0 rgba(255, 255, 255, 0);
}
.btn.btn-default {
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}
</style>


// WEBPACK FOOTER //
// src/components/Login/Login.vue